// extracted by mini-css-extract-plugin
module.exports = {"customRow":"style_customRow_gcgoR","customLabel":"style_customLabel_pooCj","customTextarea":"style_customTextarea_3vPCu"};